import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['section', 'instructionEnd']

  connect() {
    this.check()
  }

  done(event) {
    event.currentTarget.dataset.done = 'true'
    this.check()
  }

  reset(event) {
    event.currentTarget.dataset.done = 'false'
    this.check()
  }

  check(){
    let done = true

    this.sectionTargets.forEach((section) => {
      if (section.dataset.done !== 'true') {
        done = false
      }
    })

    if (done) {
      this.instructionEndTarget.classList.remove('d-none')
      this.element.dispatchEvent(new CustomEvent('sectioncomplete', { bubbles: true }))
    } else {
      this.instructionEndTarget.classList.add('d-none')
      this.element.dispatchEvent(new CustomEvent('sectionincomplete', { bubbles: true }))
    }
  }
}
